import { render, staticRenderFns } from "./toolbar-editor.vue?vue&type=template&id=9613ddbc&"
import script from "./toolbar-editor.vue?vue&type=script&lang=js&"
export * from "./toolbar-editor.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports